<template>
  <div class="workspace-history">
    <!-- skeleton -->
    <template v-if="loading">
      <skeleton-workspace-history class="workspace-history-wrapper" />
      <skeleton-workspace-history class="workspace-history-wrapper" />
      <skeleton-workspace-history class="workspace-history-wrapper" />
      <skeleton-workspace-history class="workspace-history-wrapper" />
    </template>
    <!-- el -->
    <div 
      class="workspace-history-wrapper no-result"
      v-else-if="!viewData || viewData && viewData.length === 0">
      No result.
    </div>
    <div 
      class="workspace-history-wrapper"
      v-for="(x, ind) in viewData" 
      :key="`${widget.fieldName}-${ind}-${x.id}`"
      @click="open(x)"
      v-else>
      <fts-profile
        :profilePhotoSize="35"
        :userName="x.audit && x.audit.updatedBy"
        profileNameClass="workspace-history-info"
        class="workspace-history__header">
        <template #profileName="{userProfileName}">
          <!-- alpha -->
          <div class="workspace-history-row-alpha">
            <span class="profile-name">{{userProfileName}}</span>
            <span style="white-space: pre-wrap;">{{x.changes}}</span>
          </div>
          <!-- beta -->
          <div class="workspace-history-row-beta">
            <!-- module -->
            <fts-label-group
              :item-id="x.moduleId" 
              :list="workspaceModules"
              emoji
              :emoji-size="12"
              class="d-module" 
              v-if="x.moduleId" 
            />
            <!-- audit -->
            <template v-if="x.audit && x.audit.createdDate">
              <fts-tippy class="d-audit-date" :content="moment(x.audit.createdDate).format('llll')">
                <template #trigger>{{dateFormat(x.audit.createdDate)}}</template>
              </fts-tippy>
            </template>
          </div>
        </template>
      </fts-profile>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import commons from "../../commons/commons";
import { htmlValidator } from "../../commons/validator";
import { store as canvasDesignStore } from "../../store/canvasDesignStore";

import FTSTippy from "../../elements/FTSTippy";
import FTSProfile from "../../elements/FTSProfile";
import FTSState from "../../elements/FTSState";
import FTSFile from "../../elements/file/FTSFile";
import FTSLabelGroup from "../../elements/FTSLabelGroup";
import SkeletonWorkspaceHistory from "../../elements/skeleton-screen/dashboard/SkeletonWorkspaceHistory";

export default {
  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
    viewData: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
  },
  components: {
    "fts-tippy": FTSTippy,
    "fts-profile": FTSProfile,
    "fts-state": FTSState,
    "fts-file": FTSFile,
    "fts-label-group": FTSLabelGroup,
    "skeleton-workspace-history": SkeletonWorkspaceHistory,
  },
  methods: {
    moment,
    dateFormat(date) {
      return commons.momentRelativeTime(date)
    },
    commentContent(content) {
      return htmlValidator(content)
    },
    open(item) {
      if (commons.elementStopPropagation()) return;
      this.$emit("open", item);
    },
  },
  computed: {
    workspaceModules() {
      return canvasDesignStore.getters.workspaceModules;
    },
  },
}
</script>

<style lang="scss">
.workspace-history {
  .workspace-history-wrapper {
    &:not(:first-child) {
      margin-top: 1rem;
    } 
    &:not(.no-result) {
      border-radius: 0.5rem;
      box-shadow: var(--fts-elevation-3);
      background-color: var(--fts-card-background);
      color: var(--fts-text);
      cursor: pointer;
    }
    &.no-result {
      font-size: 0.875rem;
      color: var(--fts-default);
    }
    padding: 1rem;
    .workspace-history__header {
      align-items: flex-start;
      .workspace-history-info {
        min-width: 0;
        flex: 1;
        .workspace-history-row-alpha {
          margin-bottom: .375rem;
          font-size: .875rem;
          line-height: 1.35;
          word-break: break-word;
          .profile-name {
            font-weight: 600;
          }
          .title-name {
            font-weight: 500;
          }
        }
        .workspace-history-row-beta {
          display: flex;
          align-items: center;
          .d-module + .d-audit-date {
            margin-left: .75rem;
          }
        }
      }
    }
  }
}
</style>